import { Text } from '@kanda-libs/ks-design-library';

import AddressFields from './AddressFields';
import ResidentialFields from './ResidentialFields';
import YearsAtAddressFields from './YearsAtAddressFields';
import { CLASS_NAMES } from './constants';
import useAddressFieldsWrapper from './useAddressFieldsWrapper';

export type AddressFieldType = 'current' | 'previous1' | 'previous2';

export interface AddressFieldsWrapperProps {
  addressType: AddressFieldType;
}

const AddressFieldsWrapper: React.FunctionComponent<AddressFieldsWrapperProps> =
  function ({ addressType }) {
    const { title } = useAddressFieldsWrapper(addressType);
    return (
      <div className={CLASS_NAMES.container}>
        <div className={CLASS_NAMES.header}>
          <Text className={CLASS_NAMES.title} text={title} />
        </div>
        {addressType === 'current' && <ResidentialFields />}
        <AddressFields addressType={addressType} />
        <YearsAtAddressFields addressType={addressType} />
      </div>
    );
  };

export default AddressFieldsWrapper;
